import { INewbuildingSeller } from '../../types/newbuilding/seller';

export const isLeadFactory = (agent: INewbuildingSeller): boolean => agent.isLeadFactory;
